
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import webAppScreenshot from '../assets/web-app-screenshot.png';

const demoPoints = [
  'Clinical screening with PHQ-2/GAD-2 integration',
  'Crisis-safe BridgeBot AI conversation',
  'Daily quests gamification with XP earning',
  'Integrated biofeedback, nutrition, sleep, and social tools',
];

const LiveDemo = () => {
  return (
    <DemoSection id="demo">
      <Container>
        <SectionHeading>MindBridge in Action - Interactive Demo</SectionHeading>
        <DemoWrapper>
          <VideoPlaceholder>
            <img src={webAppScreenshot} alt="MindBridge Web App Screenshot" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '15px' }} />
          </VideoPlaceholder>
          <DemoScript>
            <ul>
              {demoPoints.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
            <CTAButton to="home" smooth={true} duration={500}>Try the Full App</CTAButton>
          </DemoScript>
        </DemoWrapper>
      </Container>
    </DemoSection>
  );
};

export default LiveDemo;

const DemoSection = styled.section`
  background-color: var(--background-light);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
`;

const SectionHeading = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 4rem;
  color: var(--primary-blue-dark);

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const DemoWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 3rem;
  align-items: center;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const VideoPlaceholder = styled.div`
  width: 100%;
  max-width: 500px; /* Reduced size for the screenshot */
  aspect-ratio: 16 / 9;
  background-color: #e9ecef;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #adb5bd;
  font-size: 1.5rem;
  font-weight: 600;
  border: 2px dashed #ced4da;
`;

const DemoScript = styled.div`
  text-align: left;

  ul {
    list-style: none;
    padding: 0;
    margin: 0 0 2rem 0;
  }

  li {
    font-size: 1.1rem;
    margin-bottom: 1rem;
    padding-left: 1.5rem;
    position: relative;

    &::before {
      content: '✓';
      color: var(--secondary-green);
      position: absolute;
      left: 0;
      font-weight: 700;
    }
  }

   @media (max-width: 992px) {
    text-align: center;
    margin-top: 2rem;

    li {
      display: inline-block;
      margin: 0 1rem 1rem 1rem;
      text-align: left;
    }
  }

  @media (max-width: 768px) {
    li {
      display: list-item;
    }
  }
`;

const CTAButton = styled(Link)`
  display: inline-block;
  background: var(--primary-blue-light);
  color: white;
  padding: 15px 30px;
  border-radius: 10px;
  font-size: 1.2rem;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.3s ease;

  &:hover {
    background: var(--primary-blue-dark);
    transform: translateY(-3px);
  }
`;
